<header style="background: #000219; font-size: 14px;" class="text-white">
    <div class="container-fluid" style="padding-top: 1rem">
        <ul class="list-unstyled d-flex flex-wrap justify-content-center align-items-center mb-0">
            <li class="d-flex align-items-center me-4 mb-2">
                <i class="fa fa-calendar me-3"></i>
                <a href="#" class="text-decoration-none text-white">Monday–Friday 08:30–16:30</a>
            </li>
            <li class="d-flex align-items-center me-4 mb-2">
                <i class="fa fa-map-location me-3"></i>

                <!-- Mobile-only address -->
                <a href="https://maps.app.goo.gl/sn1Ru8vPAJmDQRqVA"
                    target="_blank"
                    rel="noopener"
                    class="text-decoration-none text-white d-block d-md-none">
                    Office 5, 377 Johannes Ramokhoase St, Pretoria Central
                </a>

                <!-- Desktop/tablet address -->
                <a href="https://maps.app.goo.gl/sn1Ru8vPAJmDQRqVA"
                    target="_blank"
                    rel="noopener"
                    class="text-decoration-none text-white d-none d-md-block">
                    Jardown 1, Office 0005, 377 Johannes Ramokhoase St, Pretoria Central, 0002
                </a>

            </li>
            <li class="d-flex align-items-center me-4 mb-2">
                <i class="fa fa-phone me-3"></i>
                <a href="tel:+27115685421" class="text-decoration-none text-white">
                    (+27) 11 568 5421
                </a>
            </li>
            <li class="d-flex align-items-center mb-2">
                <i class="fa fa-envelope me-3"></i>
                <a href="mailto:mufk@dotblack.co.za" class="text-decoration-none text-white">
                    mufk@dotblack.co.za
                </a>
            </li>
        </ul>
    </div>
</header>

<div class="container-fluid">

<nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="logo">
<!--            <a ><h3>dotBlack</h3></a>-->
            <img routerLink="/" style="height: 100px;    width: 200px;" src="/assets/img/dotBlackLogo-removebg-preview.png" alt="DotBlack"/>

        </div>

        <button class="navbar-toggler" type="button"  data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav m-auto ps-4 ps-lg-0">
                <li class="nav-item"><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Home</a></li>
                <li class="nav-item"><a routerLink="/about-us" routerLinkActive="active" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">About Us</a></li>
                <li
  class="nav-item2 hide-on-mobile"
  (mouseenter)="open = true"
  (mouseleave)="open = false"
  [class.active]="isSolutionsActive"
  data-bs-toggle="collapse"
  data-bs-target=".navbar-collapse.show"
>
  <a
    class="nav-link"
    href="#"
    id="solutionsDropdown"
    role="button"
    [attr.aria-expanded]="open"
    [class.show]="open"
    (click)="$event.preventDefault()"
  >
    Our Solutions<span class="tab-indicator"></span>
  </a>

  <ul class="dropdown-menu" [class.show]="open" aria-labelledby="solutionsDropdown">
    <li>
      <a
        class="dropdown-item"
        routerLink="/products/solution1"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        Budget insights
      </a>
    </li>
    <li>
      <a
        class="dropdown-item"
        routerLink="/products/solution2"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        Muf-k.integrate
      </a>
    </li>
  </ul>
</li>
                <li class="nav-item"><a routerLink="/products/solution1" routerLinkActive="active" class="nav-link hide-on-desktop" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Our Solution: Budget Insights</a></li>
                <li class="nav-item"><a routerLink="/products/solution2" routerLinkActive="active" class="nav-link hide-on-desktop" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Our Solution: MUF-K.INTEGRATE</a></li>


              <!--  <li class="nav-item"><a routerLink="/products" routerLinkActive="active" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Our Solutions</a></li> -->
                <li class="nav-item"><a routerLink="/it-consulting" routerLinkActive="active" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">IT Consulting</a></li>
                <li class="nav-item"><a routerLink="/rpa" routerLinkActive="active" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">RPA</a></li>
                <li class="nav-item"><a routerLink="/project-management" routerLinkActive="active" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Project Management</a></li>
                <li class="nav-item"><a routerLink="/it-services" routerLinkActive="active" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">IT Resource Augmentation</a></li>
               <!--<li class="nav-item"><a routerLink="/initiatives" routerLinkActive="active" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Our Initiatives</a></li>-->
            </ul>

            <div class="others-option ps-4 ps-sm-0 pt-4 pt-sm-0">
                <div class="d-flex align-items-center">
                    <div class="option-item">
                        <a style="text-decoration: none; color: white !important;" routerLink="/contact" class="default-btn" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Contact Us<span></span></a>
                    </div>
                </div>
            </div>
        </div>

</nav>
</div>
